import { RouteConfig } from 'vue-router'
import { RouteName, RoutePath } from './enum'
import MainWrapper from '@/components/MainWrapper.vue'

const LandingPage = () => import(/* webpackChunkName: "LandingPage" */ '@/views/landing-page/LandingPage.vue')
const SupportPage = () => import(/* webpackChunkName: "SupportPage" */ '@/views/support-page/SupportPage.vue')
const ContactFormPage = () => import(/* webpackChunkName: "ContactFormPage" */ '@/views/contact-form-page/ContactFormPage.vue')
const WhereDoYouLivePage = () => import(/* webpackChunkName: "WhereDoYouLivePage" */ '@/views/where-do-you-live-page/WhereDoYouLivePage.vue')
const ServiceProvidersPage = () => import(/* webpackChunkName: "ServiceProvidersPage" */ '@/views/service-providers-page/ServiceProvidersPage.vue')
const SimplePage = () => import(/* webpackChunkName: "SimplePage" */ '@/views/simple-page/SimplePage.vue')
const OrderFlowPage = () => import(/* webpackChunkName: "OrderFlowPage" */ '@/views/order-flow-page/OrderFlowPage.vue')
const OrderDetailsPage = () => import(/* webpackChunkName: "OrderDetailsPage" */ '@/views/order-details-page/OrderDetailsPage.vue')
const CampaignExpiredPage = () => import(/* webpackChunkName: "CampaignExpiredPage" */ '@/views/order-flow-page/CampaignExpiredPage.vue')
const OrderSuccessPage = () => import(/* webpackChunkName: "OrderSuccessPage" */ '@/views/order-success-page/OrderSuccessPage.vue')
const NoticeOfInterestGenericPage = () => import(/* webpackChunkName: "NoticeOfInterestGenericPage" */ '@/views/notice-of-interest-page/NoticeOfInterestGenericPage.vue')
const NoticeOfInterestAreaPage = () => import(/* webpackChunkName: "NoticeOfInterestAreaPage" */ '@/views/notice-of-interest-page/NoticeOfInterestAreaPage.vue')
const StatusPage = () => import(/* webpackChunkName: "StatusPage" */ '@/views/status-page/StatusPage.vue')
const NoticeOfInterestAlreadyRegisteredContainer = () => import(/* webpackChunkName: "NoticeOfInterestAlreadyRegisteredContainer" */ '@/views/notice-of-interest-page/already-registered/NoticeOfInterestAlreadyRegisteredContainer.vue')
const AccessPage = () => import(/* webpackChunkName: "AccessPage" */ '@/views/access-page/AccessPage.vue')
const LandlordPage = () => import(/* webpackChunkName: "LandlordPage" */ '@/views/landlord/LandlordPage.vue')
const LandlordContactPage = () => import(/* webpackChunkName: "LandlordContactPage" */ '@/views/landlord-contact-page/LandlordContactPage.vue')
const LandlordOrderPage = () => import(/* webpackChunkName: "LandlordOrderPage" */ '@/views/landlord-order-page/LandlordOrderPage.vue')
const LandlordOrderOrganisation = () => import(/* webpackChunkName: "LandlordOrderOrganisation" */ '@/views/landlord-order-page/LandlordOrderOrganisation.vue')
const LandlordOrderServices = () => import(/* webpackChunkName: "LandlordOrderServices" */ '@/views/landlord-order-page/LandlordOrderServices.vue')
const LandlordOrderProperty = () => import(/* webpackChunkName: "LandlordOrderProperty" */ '@/views/landlord-order-page/LandlordOrderProperty.vue')
const LandlordOrderContact = () => import(/* webpackChunkName: "LandlordOrderContact" */ '@/views/landlord-order-page/LandlordOrderContact.vue')
const LandlordOrderSummary = () => import(/* webpackChunkName: "LandlordOrderSummary" */ '@/views/landlord-order-page/LandlordOrderSummary.vue')

export const routes: RouteConfig[] = [{
  path: '/',
  component: MainWrapper,
  children: [
    {
      path: RoutePath.LandingPage,
      name: RouteName.LandingPage,
      component: LandingPage
    },
    {
      path: RoutePath.OrderPage,
      name: RouteName.OrderPage,
      props: /* istanbul ignore next */ (route) => ({ scrollToAddressSearch: route.params.scrollToAddressSearch }),
      component: LandingPage
    },
    {
      path: RoutePath.SupportPage + '/:product/:category',
      name: RouteName.SupportPage,
      component: SupportPage
    },
    {
      path: RoutePath.SupportPage,
      name: RouteName.SupportPageDefault,
      component: SupportPage
    },
    {
      path: RoutePath.ContactFormPage,
      name: RouteName.ContactFormPage,
      component: ContactFormPage
    },
    {
      path: RoutePath.WhereDoYouLivePage,
      name: RouteName.WhereDoYouLivePage,
      component: WhereDoYouLivePage
    },
    {
      path: RoutePath.ServiceProviders,
      name: RouteName.ServiceProviders,
      component: ServiceProvidersPage
    },
    {
      path: `${RoutePath.SimplePage}/:path(.*)`,
      name: RouteName.SimplePage,
      props: /* istanbul ignore next */ (route) => ({ path: route.params.path }),
      component: SimplePage
    },
    {
      path: RoutePath.OrderFlowPage,
      name: RouteName.OrderFlowPage,
      props: /* istanbul ignore next */ (route) => ({
        areaType: route.params.areaType,
        areaStatus: route.params.areaStatus
      }),
      component: OrderFlowPage
    },
    {
      path: RoutePath.OrderDetailsPage,
      name: RouteName.OrderDetailsPage,
      component: OrderDetailsPage
    },
    {
      path: RoutePath.CampaignExpiredPage,
      name: RouteName.CampaignExpiredPage,
      component: CampaignExpiredPage
    },
    {
      path: `${RoutePath.OrderSuccessPage}/:customerGuid/:addressId`,
      name: RouteName.OrderSuccessPage,
      component: OrderSuccessPage
    },
    {
      path: RoutePath.NoticeOfInterestGenericPage,
      name: RouteName.NoticeOfInterestGenericPage,
      component: NoticeOfInterestGenericPage
    },
    {
      path: RoutePath.NoticeOfInterestAreaPage,
      name: RouteName.NoticeOfInterestAreaPage,
      component: NoticeOfInterestAreaPage
    },
    {
      path: RoutePath.StatusPage,
      name: RouteName.StatusPage,
      component: StatusPage
    },
    {
      path: RoutePath.NoticeOfInterestAlreadyRegisteredPage,
      name: RouteName.NoticeOfInterestAlreadyRegisteredPage,
      component: NoticeOfInterestAlreadyRegisteredContainer
    },
    {
      path: `${RoutePath.Access}/:addressId/:referralId?`,
      name: RouteName.Access,
      component: AccessPage
    }
  ]
}, {
  path: RoutePath.LandlordPage,
  component: MainWrapper,
  children: [
    {
      path: RoutePath.LandlordPage,
      name: RouteName.LandlordPage,
      component: LandlordPage
    },
    {
      path: RoutePath.LandlordContactPage,
      name: RouteName.LandlordContactPage,
      component: LandlordContactPage
    },
    {
      path: RoutePath.LandlordOrderPage,
      name: RouteName.LandlordOrderPage,
      component: LandlordOrderPage,
      redirect: RoutePath.LandlordOrderOrganisation,
      children: [
        {
          path: RoutePath.LandlordOrderOrganisation,
          name: RouteName.LandlordOrderOrganisation,
          component: LandlordOrderOrganisation
        },
        {
          path: RoutePath.LandlordOrderServices,
          name: RouteName.LandlordOrderServices,
          component: LandlordOrderServices
        },
        {
          path: RoutePath.LandlordOrderProperty,
          name: RouteName.LandlordOrderProperty,
          component: LandlordOrderProperty
        },
        {
          path: RoutePath.LandlordOrderContact,
          name: RouteName.LandlordOrderContact,
          component: LandlordOrderContact
        },
        {
          path: RoutePath.LandlordOrderSummary,
          name: RouteName.LandlordOrderSummary,
          component: LandlordOrderSummary
        }
      ]
    }
  ]
}]
